import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Form, Input, InputNumber, Radio, Modal, Cascader ,Drawer , Button } from 'antd'
import { FormBuilder } from '../../components'

const FormItem = Form.Item

const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}

class FormDraw extends Component {
    static propTypes = {

    };
  
    handleOk = () => {
      const { item = {}, onOk, form } = this.props
      const { validateFields, getFieldsValue } = form
  
      validateFields(errors => {
        if (errors) {
          return
        }
        const data = {
          ...getFieldsValue(),
          id: item.id,
        }
        onOk(data)
      })
    }
  
    render() {
      const { item = {}, onClose, onOk,elements, form,  ...drawerProps } = this.props
  
      const formMeta = {
        colon: true,
        columns: 1,
        formItemLayout: formItemLayout,
        elements: elements
      };

      return (<Drawer {...drawerProps}>
      <Form layout="horizontal"><FormBuilder meta={formMeta} form={form} /></Form>
        <div
            style={{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right'
            }}
          >
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              取消
            </Button>
            <Button onClick={this.handleOk} type="primary">
              提交
            </Button>
          </div>
      </Drawer>);
    }
}
const WrapperModal = Form.create({ name: 'form_draw' })(FormDraw);

export default WrapperModal


// WEBPACK FOOTER //
// ./src/components/Crud/CrudDraw.js